import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import IApproveRejectTradeAnalysisRequest from 'src/components/common/GenericButtons/ApproveRejectTradeAnalysis/IApproveRejectTradeAnalysisRequest';
import IAnalysis from '../interface/Analysis/IAnalysis';

enum TradeAnalysisServiceEnum {
  phaseApprove = "approve",
  phaseReject = "reject",
  getByTradeId = "",
  getAnalysisByTradeId = "GetAnalysisByTradeId/",
}

export default class TradeAnalysisService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/trade/analysis/");
  }

  public putInPhaseApprove = async (data: IApproveRejectTradeAnalysisRequest) => await this.PUT(TradeAnalysisServiceEnum.phaseApprove, data);
  public putInPhaseReject = async (data: IApproveRejectTradeAnalysisRequest) => await this.PUT(TradeAnalysisServiceEnum.phaseReject, data);
  public getByTradeId = async (tradeId: number): Promise<IAnalysis> => await this.GET(TradeAnalysisServiceEnum.getByTradeId + tradeId);
  public getAnalysisByTradeId = async (tradeId: number): Promise<IAnalysis> => await this.GET(TradeAnalysisServiceEnum.getAnalysisByTradeId + tradeId);
}



// WEBPACK FOOTER //
// ./src/services/api/TradeAnalysis.service.ts